<div [class]="currentTheme.baseSettings.subHeader.containerStyle">
    <div [class]="containerClass + ' d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap'">
        <div class="d-flex align-items-center flex-wrap mr-2">
            @if (currentTheme.baseSettings.subHeader.subheaderSize == 1) {
                <h1 [class]="currentTheme.baseSettings.subHeader.titleStlye">{{ title }}</h1>
            }
            @if (currentTheme.baseSettings.subHeader.subheaderSize == 2) {
                <h2 [class]="currentTheme.baseSettings.subHeader.titleStlye">{{ title }}</h2>
            }
            @if (currentTheme.baseSettings.subHeader.subheaderSize == 3) {
                <h3 [class]="currentTheme.baseSettings.subHeader.titleStlye">{{ title }}</h3>
            }
            @if (currentTheme.baseSettings.subHeader.subheaderSize == 4) {
                <h4 [class]="currentTheme.baseSettings.subHeader.titleStlye">{{ title }}</h4>
            }
            @if (currentTheme.baseSettings.subHeader.subheaderSize == 5) {
                <h5 [class]="currentTheme.baseSettings.subHeader.titleStlye">{{ title }}</h5>
            }
            @if (currentTheme.baseSettings.subHeader.subheaderSize == 6) {
                <h6 [class]="currentTheme.baseSettings.subHeader.titleStlye">{{ title }}</h6>
            }
            @if (description) {
                <div class="subheader-separator subheader-separator-ver mt-2 mb-2 mr-4 bg-gray-200"></div>
            }
            @if (description) {
                <div class="d-flex align-items-center">
                    <span class="text-muted font-weight-bold mr-4">{{ description }}</span>
                </div>
            }
            @if (breadcrumbs && breadcrumbs.length > 0) {
                <div class="subheader-separator subheader-separator-ver mt-2 mb-2 mr-4 bg-gray-200"></div>
            }
            @if (breadcrumbs && breadcrumbs.length > 0) {
                <ul class="breadcrumb breadcrumb-transparent breadcrumb-dot font-weight-bold p-0 my-2 font-size-sm">
                    @for (breadcrumbItem of breadcrumbs; track breadcrumbItem) {
                        <li class="breadcrumb-item">
                            @if (breadcrumbItem.isLink()) {
                                <a style="cursor: pointer" (click)="goToBreadcrumb(breadcrumbItem)" class="text-muted">
                                    {{ breadcrumbItem.text }}
                                </a>
                            }
                            @if (!breadcrumbItem.isLink()) {
                                <span class="text-muted">{{ breadcrumbItem.text }}</span>
                            }
                        </li>
                    }
                </ul>
            }
        </div>
        <div class="d-flex align-items-center">
            <ng-content select="div[role=actions]"></ng-content>
        </div>
    </div>
</div>
